import { setIncreaseCount } from './loading-counter/actions';
import { fetchBrands, fetchLocations } from './public-data/actions';
import { createAction } from './utils';

export const startPublicApiSync = createAction(`API:START_PUBLIC_SYNC`, async ({ dispatch }) => {
    // Public APIS
    await Promise.all([
        dispatch(fetchLocations()).then(() => dispatch(setIncreaseCount())),
        dispatch(fetchBrands()).then(() => dispatch(setIncreaseCount())),
    ]);
});
